<template>
  <collapsible>
    <ul
      v-if="isOpen"
      class="primary-menu-submenu"
      :aria-labelledby="labelledBy"
    >
      <li v-for="item in subMenu.children" :key="item.name">
        <item
          :id="primarySubmenuId(item)"
          :item="item"
          :current-url="currentUrl"
          @itemSelected="item => $emit('itemSelected', item)"
        />
      </li>
    </ul>
  </collapsible>
</template>

<script>
import Collapsible from '../Shared/Collapsible';
import Item from './Item';

export default {
  components: {
    Collapsible,
    Item
  },
  props: {
    subMenu: {
      type: Object,
      default: () => ({})
    },
    currentUrl: {
      type: String,
      default: null
    },
    primaryMenuActiveItem: {
      type: String,
      default: null
    },
    primaryMenuOpen: {
      type: Boolean,
      default: true
    },
    labelledBy: {
      type: String,
      default: ''
    }
  },
  computed: {
    isOpen() {
      return (
        this.primaryMenuActiveItem === this.subMenu.name && this.primaryMenuOpen
      );
    }
  },
  methods: {
    primarySubmenuId(item) {
      return 'primary-submenu-' + item.name;
    }
  }
};
</script>
